module.exports = __webpack_public_path__ + "media/invite/play-606644ed.svg";